var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUkFlag = function SvgUkFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M25.4 51.76c9.477 0 17.16-.931 17.16-2.08S34.877 47.6 25.4 47.6s-17.16.931-17.16 2.08 7.683 2.08 17.16 2.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4ABB3",
    d: "M12 32h2v17.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "M12 31h2v5h-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#307CAB",
    d: "M12 18.8a1.8 1.8 0 0 1 1.8-1.8H39a1.8 1.8 0 0 1 1.8 1.8v14.4A1.8 1.8 0 0 1 39 35H12V18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.344 18.64-1.956-3.256L10.456 33.36l1.956 3.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.456 18.64 1.956-3.256L42.343 33.36l-1.955 3.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA6753",
    d: "m41.781 17.703-.83-1.383-29.932 17.976.83 1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA6753",
    d: "m11.019 17.703.83-1.383 29.932 17.976-.83 1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.475 17h5.85v18h-5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2 28.925v-5.85h32.4v5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA6753",
    d: "M24.825 17h3.15v18h-3.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA6753",
    d: "M10.2 27.575v-3.15h32.4v3.15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18.8a1.8 1.8 0 0 1 1.8-1.8H39a1.8 1.8 0 0 1 1.8 1.8v14.4A1.8 1.8 0 0 1 39 35H12V18.8Z"
  })))));
};
export default SvgUkFlag;